import { render, staticRenderFns } from "./FilesTemplates.vue?vue&type=template&id=54214c72&scoped=true&"
import script from "./FilesTemplates.vue?vue&type=script&lang=js&"
export * from "./FilesTemplates.vue?vue&type=script&lang=js&"
import style0 from "./FilesTemplates.vue?vue&type=style&index=0&id=54214c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54214c72",
  null
  
)

export default component.exports